konnyScript(function ($) {
    // 1. Swiper 초기화 (중앙 정렬 및 양 끝 여백 방지 설정)
	var tabNavSlide = new Swiper("#tab_nav_swiper_slide", {
		slidesPerView: 'auto',
		grabCursor: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        normalizeSlideIndex: true
	});

    // Tab Scroll & Click Logic
	(function () {
		const $tabs = $('.eventWrap .navWrap li');
		const sections = [...Array($tabs.length)].map((_, i) => $('#tabCon' + (i + 1)));
        
        let isFromClick = false;
        let scrollWatcher;

        // 탭 클릭 이벤트
		$('#tab_nav_swiper_slide a').on('click', function (e) {
			e.preventDefault();
			const $li = $(this).closest('li');
			const index = $li.index();

			$li.addClass('on').siblings().removeClass('on');
			tabNavSlide.slideTo(index);

			const headerHeight = $('#header').outerHeight() || 0;
			const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
			const fixHeight = headerHeight + navHeight;
			const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top) || (window.innerWidth <= 749 ? 103 : 68);

			const targetSection = $('#tabCon' + (index + 1));

			if (targetSection.length) {
                const targetTop = targetSection.offset().top - fixHeight - fixedTop;

                isFromClick = true;
                window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });

                cancelAnimationFrame(scrollWatcher);
                function watchScroll() {
                    const current = $(window).scrollTop();
                    if (Math.abs(current - targetTop) < 3) {
                        isFromClick = false;
                        $(window).trigger('scroll');
                        return;
                    }
                    scrollWatcher = requestAnimationFrame(watchScroll);
                }
                watchScroll();
            }
        });

        // 윈도우 스크롤 이벤트
        $(window).on('load scroll', function () {
            if (!$('.eventWrap .navWrap').length || isFromClick) return;

            const headerHeight = $('#header').outerHeight() || 0;
            const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
            const fixHeight = headerHeight + navHeight;
            const winTop = $(window).scrollTop();
            
            // 변수명 변경: bwNavTop -> navTop
			const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top, 10) || (window.innerWidth <= 749 ? 103 : 68);
            const navTop = $('.eventWrap .navArea').offset().top - fixedTop;

            let activeIndex = -1;
            const ACTIVATION_OFFSET = -150;

            for (let i = sections.length - 1; i >= 0; i--) {
                if (winTop > sections[i].offset().top - fixedTop + ACTIVATION_OFFSET) {
                    activeIndex = i;
                    break;
                }
            }

            // 네비게이션 고정 처리 (navTop 변수 사용)
            if (winTop > navTop) {
                $('.eventWrap .navWrap').addClass('fixed');
            } else {
                $('.eventWrap .navWrap').removeClass('fixed');
            }

            // 활성 탭 업데이트 및 Swiper 이동
            if (activeIndex !== -1) {
                const $activeTab = $tabs.eq(activeIndex);
                if (!$activeTab.hasClass('on')) {
                    $activeTab.addClass('on').siblings().removeClass('on');
                    tabNavSlide.slideTo(activeIndex);
                }
            } else {
                $tabs.removeClass('on');
            }
        });
    })();
});